<template>
	<div>
		<el-page-header @back="goBack" content="资源数据"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 资源：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>
			</div>
		</div>
		<div class="topic-outer">
			<div class="appraisal-center fonts marr">
				<div class="marr">
					<el-button
						type="success"
						size="small"
						@click="handleSubjectIncrease('add')"
						>添加 <i class="el-icon-plus"></i
					></el-button>
				</div>
				<div style="margin-top: 20px" v-if="dimensionInfo.code != 'IBB'">
					<div class="public-table-data">
						<el-table
							ref="multipleTable"
							size="medium"
							:data="tableData"
							border
							style="width: 100%"
							row-key="menuId"
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="80"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="name"
								label="标题"
								width="120"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="content"
								label="内容"
								min-width="300"
								align="center"
							>
								<template slot-scope="scope">
									<div
										style="
											max-height: 50px;
											overflow: hidden;
											text-overflow: ellipsis;
											white-space: nowrap;
										"
										v-html="scope.row.content"
									></div>
								</template>
							</el-table-column>
							<el-table-column
								label="操作"
								align="center"
								fixed="right"
								min-width="220"
							>
								<template slot-scope="scope">
									<el-button
										size="mini"
										@click="handleSubjectIncrease('edit', scope.row)"
										type="success"
										plain
										>编辑
									</el-button>
									<el-button
										size="mini"
										@click="handleDelete(scope.row)"
										type="danger"
										plain
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div style="margin-top: 12px" v-else>
					<el-tag
						effect="plain"
						class="tag-marr"
						:key="index"
						v-for="(item, index) in tableData"
						type="success"
						>{{ item.seq }}
					</el-tag>
				</div>
			</div>
		</div>
		<!-- 添加 编辑 资源弹框 -->
		<el-dialog
			title="添加/编辑资源"
			:visible.sync="dialogVisibleTopic"
			width="80%"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleFormTopic"
					:rules="rulesTopic"
					:model="topicParams"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('question')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-form-item prop="name" label="标题">
						<el-input
							placeholder="请填写标题"
							v-model="topicParams.name"
						></el-input>
					</el-form-item>
					<el-form-item prop="subtitle" label="副标题">
						<el-input
							placeholder="请填写副标题"
							v-model="topicParams.subtitle"
						></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="content">
						<rich-text
							:keyWord="'content'"
							:params="topicParams ? topicParams : ''"
						></rich-text>
					</el-form-item>
					<el-form-item prop="description" label="评论">
						<el-input
							placeholder="请填写评论"
							v-model="topicParams.description"
							type="textarea"
							:autosize="{ minRows: 8, maxRows: 18 }"
						></el-input>
					</el-form-item>
					<el-form-item prop="buttonText" label="按钮文案">
						<el-input
							placeholder="请填写按钮文案"
							v-model="topicParams.buttonText"
						></el-input>
					</el-form-item>
					<el-form-item class="item" label="附件">
						<upLoadImg
							:keyWord="'downloadUrl'"
							:params="topicParams"
							v-if="flag"
						></upLoadImg>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisibleTopic = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEditTopic"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import upLoadImg from "@views/international/components/upLoadImg";
import richText from "@comp/richText";

import { emptyShow, isEmpty } from "@utils/tools";
import { getEditFormConfig } from "./zyList.js";

export default {
	name: "mjywlList",
	components: { upLoadImg, richText },
	data() {
		return {
			dimensionInfoList: [],
			emptyShow,
			isEmpty,
			loading: false,
			detalisObj: {},
			dimensionList: [],
			dialogVisible: false,
			rules: {
				name: [{ required: true, message: "请填写标题", trigger: "change" }],
				overview: [
					{ required: true, message: "简单的资源描述", trigger: "change" },
				],
			},
			formModelConfig: getEditFormConfig(),
			flag: true,
			params: {},
			srcList: [],
			isMoer: true,
			dimensionInfoId: 0,
			dimensionInfo: {},
			datumList: [],
			datumId: "",
			datumInfo: {},
			tableData: [],
			dialogVisibleTopic: false,
			topicParams: {},
			rulesTopic: {
				view: [{ required: true, message: "请选择布局", trigger: "change" }],
				name: [{ required: true, message: "请填写资源", trigger: "change" }],
			},
			clickType: "",
			dialogVisibleAnswer: false,
			dialogVisibleQuestion: false,
			questionTableData: [],
			answerParams: {},
			answerTableData: [],
			answerDataIndex: "",
			srcListAnswer: [],
			isMoerAnswer: true,
			languageList: [],
			languageCode: "",
			multipleSelection: [],
		};
	},
	mounted() {
		this.getAppraisalData(true);
		this.getLanguageList();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick(e) {
			if (e == "question") {
				this.srcList = [];
				this.isMoer = false;
				if (this.topicParams.id) {
					this.getSubjectInfo(this.topicParams.id);
				} else {
					this.isMoer = true;
				}
			}
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData(e) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;
			if (e) {
				this.getDimensionList();
			}
		},
		/**
		 * 获取测评维度列表
		 */
		async getDimensionList() {
			this.dimensionList = [];
			this.loading = true;
			const { data: resData } = await this.$get(
				`/merchant/vip/resource//${this.detalisObj.examInfoId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.tableData = resData.data;
				console.log("🚀 ~   ~ getDimensionList ~ resData.data;:", resData.data);
			}
		},
		/**
		 * 测评资源添加/编辑相关
		 */
		async handleSubjectIncrease(type, data) {
			this.clickType = type;
			if (type == "add") {
				this.isMoer = true;
				this.topicParams = {};
				this.srcList = [];
				this.dialogVisibleTopic = true;
			} else if (type == "edit") {
				this.getSubjectInfo(data.id);
				this.dialogVisibleTopic = true;
			}
		},
		/**
		 * 测评资源删除
		 */
		async handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`/merchant/vip/resource/delete/${row.id}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getAppraisalData(true); //刷新总资源
				this.$message.success("删除成功!");
			});
		},
		/**
		 * 测评资源数据提交
		 */
		handleEditTopic() {
			this.$refs.ruleFormTopic.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.topicParams.examInfoId = this.detalisObj.examInfoId;
					this.topicParams.title = this.topicParams.name;
					if (this.clickType == "add") {
						const { data: resData } = await this.$post(
							"/merchant/vip/resource/add",
							this.topicParams,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.$message.success("添加成功!");
					} else if (this.clickType == "edit") {
						const { data: resData } = await this.$post(
							"/merchant/vip/resource/update",
							this.topicParams,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						// this.dialogVisibleTopic = false;
						this.$message.success("修改成功!");
					}
					this.getAppraisalData(true); //刷新总资源
				});
			});
		},
		/**
		 * 测评资源详情
		 */
		async getSubjectInfo(id) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/merchant/vip/resource/detail/${id}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.topicParams = resData.data;
		},
		goBack() {
			this.$router.back();
		},
	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.activeBg {
	background: #b3d8ff;
	color: #fff;
}
.activeBg1 {
	background: #fbc4c4;
	color: #fff;
}
</style>
